import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Unikai',       //theme name
        // 'https://rest.unikai.com/',
        // 'https://unikai.crafttechhub.com/',
        'https://api.unikaii.com/'
    )
}

